<div id="root-div">
  <div class="container">
    @if (loggedIn) {
      <core-device class="sticky"></core-device>
    }
    @if (loggedIn && isDevicePrimary) {
      <banner-notifications></banner-notifications>
    }
    @if (loggedIn) {
      <reported-timecard-status class="sticky"></reported-timecard-status>
    }
    @if (loggedIn) {
      <app-tech-information class="sticky"></app-tech-information>
    }
    @if (!lunch || hideLunch) {
      <router-outlet>
      </router-outlet>
    }
    <router-outlet name="overlay"></router-outlet>
    @if (loggedIn && lunch && !hideLunch) {
      <lib-lunch-timer [disableEndLunch]="isOnLockout" [techStatus]="profileStatus?.vxFieldStatus" (endVxField)="lunchTimerCalledEndVxField()" (endLunchAlarm)="endLunchAlarm($event)"></lib-lunch-timer>
    }
  </div>

  @if (loggedIn) {
    <app-navigation id="navigation" [omegaMode]="omegaMode" [showUrgentMessageIcon]="shouldShowUrgentMessage" [showNewMessageNotification]="showNewMessageNotification" [isOnLunch]="lunch"
    ></app-navigation>
  }

</div>